import useAppStore from "@/context/store";
import { getGrocery } from "@/services";
import { getExpsValue } from "@/tracker/abTest";
import reporter from "@/tracker/report/reporter";
import { getPage } from "@/tracker/shared/global";
import { isGdMerged } from "@/utils/gaoding";
import { globalDialogControl } from "@/utils/globalDialog";
import { checkLogin } from "@/utils/open";
import Router from "next/router";
import { GDMergeDialog } from "./Dialog";
import { checkIsBigCompanyUser, checkUnpayOrder } from "./shared";

export async function goGdMerge({
  redirectUri,
  target = "_blank",
  showMessage = true,
  needGlobalControl,
  needAutoMerge = true,
  user: userInfo,
}: {
  target?: string;
  redirectUri?: string;
  showMessage?: boolean;
  needGlobalControl?: boolean;
  needAutoMerge?: boolean;
  user?: IUser;
} = {}) {
  const user = userInfo || (await checkLogin());

  if (!user?.user_id || location.pathname === "/gdmerge") {
    return;
  }

  if (isGdMerged(user)) {
    return true;
  }

  let pageConf = await getGrocery<any>("gdmerge-conf");

  // 如果有设置ab
  if (pageConf?.abTestVar) {
    // 获取abtest实验值
    const abValue = await getExpsValue(pageConf.abTestVar);
    // 根据ab实验值，找到对应的配置，并返回
    pageConf =
      pageConf.abTestStrategy.find((item) => item.abValue === abValue) ||
      pageConf;
  }

  // 前置校验
  const checks = await Promise.all([
    checkUnpayOrder(showMessage),
    checkIsBigCompanyUser(showMessage),
  ]);

  // 校验不通过
  if (checks.some((check) => check)) {
    return;
  }

  return new Promise((resolve) => {
    const props = {
      pageConf,
      needAutoMerge,
      onOk() {
        if (redirectUri) {
          if (target === "_blank") {
            window.open(redirectUri);
          } else {
            Router.push(redirectUri);
          }
        }

        useAppStore.getState().refreshUser();
        useAppStore.getState().refreshUserPermissions();

        resolve(true);
      },
      afterClose() {
        const page = getPage();

        resolve(false);

        reporter({
          ...page,
          event_id: 39008,
          event_name: "button_click",
          button_name: "关闭合并弹窗",
          button_click_type: "click",
        });
      },
    };

    if (needGlobalControl) {
      // 全局弹窗控制优先级，避免多个弹窗触发
      globalDialogControl.push({
        dialog: GDMergeDialog,
        props,
        key: "GDMergeDialog",
        priority: 0,
      });
    } else {
      GDMergeDialog.open(props);
    }
  });
}
